import { spansOfAxis, weightInSpan } from './boxSpan.js';
export function foregroundMajorityOfBox(frames, frameWeights, sourceWidth, spanI, spanJ, labels, counts) {
    let majority = 0;
    let majorityCount = 0;
    labels.length = 0;
    counts.length = 0;
    for (let f = 0; f < frames.length; f++) {
        const frame = frames[f];
        const frameWeight = frameWeights?.[f] ?? 1;
        for (let j = spanJ.first; j < spanJ.end; j++) {
            const row = j * sourceWidth;
            const rowWeight = frameWeight * weightInSpan(spanJ, j);
            for (let i = spanI.first; i < spanI.end; i++) {
                const label = frame[row + i];
                if (label === 0) {
                    continue;
                }
                let slot = labels.indexOf(label);
                if (slot === -1) {
                    slot = labels.length;
                    labels.push(label);
                    counts.push(0);
                }
                const count = (counts[slot] += rowWeight * weightInSpan(spanI, i));
                if (count > majorityCount) {
                    majorityCount = count;
                    majority = label;
                }
            }
        }
    }
    return majority;
}
export default function fillPlaneByForegroundMajority(frames, [sourceWidth, sourceHeight], [width, height], [factorI, factorJ], values, frameWeights) {
    const labels = [];
    const counts = [];
    const columns = spansOfAxis(sourceWidth, width, factorI);
    const rows = spansOfAxis(sourceHeight, height, factorJ);
    for (let targetJ = 0; targetJ < height; targetJ++) {
        for (let targetI = 0; targetI < width; targetI++) {
            values[targetJ * width + targetI] = foregroundMajorityOfBox(frames, frameWeights, sourceWidth, columns[targetI], rows[targetJ], labels, counts);
        }
    }
}
